import axios from "axios";
import { useInfiniteQuery } from "react-query";
import { BASE_PATH } from "./commonApi";
import { IHeadersProps, headersState } from "../recoil/userInfoAtom";
import { isProfilePageState } from "recoil/contentsAtom";
import { useRecoilValue } from "recoil";

interface IProps {
  idx: string | undefined;
}

export const useInfiniteScrollQuery = (props: IProps) => {
  const isProfilePage = useRecoilValue(isProfilePageState);
  const headers = useRecoilValue(headersState);
  const type = isProfilePage
    ? "profile_comments_board_list"
    : "comments_board_list";

  const getPageBoard = async ({ pageParam = 1 }) => {
    const api = isProfilePage
      ? `${BASE_PATH}/api/vfunlounge/profile/post/comment/${props.idx}?page=${pageParam}`
      : `${BASE_PATH}/api/vfunlounge/comments/${props.idx}?page=${pageParam}`;

    const res = await axios.get(api, { headers: { ...headers } });

    return {
      result: res.data.result,
      boardpage: res.data.result === 1 ? res.data.data.data : "",
      currentpage: res.data.result === 1 ? pageParam : 0,
      isLast:
        res.data.result === 1
          ? res.data.data.current_page === res.data.data.last_page
            ? true
            : false
          : 0
    };
  };

  const {
    isLoading,
    data: getBoard,
    fetchNextPage: getNextPage,
    isSuccess: getBoardIsSuccess,
    hasNextPage: getNextPageIsPossible
  } = useInfiniteQuery([type], getPageBoard, {
    getNextPageParam: (lastPage, pages) => {
      // lastPage와 pages는 콜백함수에서 리턴한 값을 의미한다!!
      // lastPage: 직전에 반환된 리턴값, pages: 여태 받아온 전체 페이지
      if (!lastPage.isLast) return lastPage.currentpage + 1;
      // 마지막 페이지면 undefined가 리턴되어서 hasNextPage는 false가 됨!
      return undefined;
    }
  });

  // const data = getBoard?.pages[0];

  return {
    getBoard,
    getNextPage,
    getBoardIsSuccess,
    getNextPageIsPossible,
    isLoading
  };
};

interface deleteProps {
  headers: IHeadersProps;
  deleteApi: string;
}

export const CommentsDeleteApi = async (props: deleteProps) => {
  const { deleteApi, headers } = props;
  const res = await axios.delete(deleteApi, { headers: { ...headers } });

  return res;
};
